module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: _vm.consultant_id ? 'Ubah Konsultan' : 'Tambah Konsultan'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-20 mt-3 mb-5"
  }, [_vm._v("\n        " + _vm._s(_vm.consultant_id ? "Ubah Konsultan" : "Tambah Konsultan") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "mb-10",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "border-bottom py-3"
  }, [_c('div', {
    staticClass: "font-size-16 black--text"
  }, [_vm._v("Data Konsultan")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', [_c('label', [_vm._v("\n                        Nama Konsultan\n                        "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan Nama Konsultan",
      "outlined": "",
      "dense": "",
      "maxlength": "50",
      "rules": [
        function (v) { return !!v || 'Nama Konsultan Wajib Diisi!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(" Email "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan Email Konsultan",
      "outlined": "",
      "dense": "",
      "maxlength": "50",
      "disabled": _vm.consultant_id,
      "readonly": _vm.consultant_id,
      "rules": [
        function (v) { return !!v || 'Email Konsultan Wajib Diisi!'; },
        function (v) { return /.+@.+\..+/.test(v) ||
        'Format email harus sesuai!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                        No. Handphone\n                        "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan No. Handphone Konsultan",
      "outlined": "",
      "dense": "",
      "maxlength": "16",
      "rules": [
        function (v) { return !!v ||
        'No. Handphone Konsultan Wajib Diisi!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.no_handphone),
      callback: function($$v) {
        _vm.$set(_vm.form, "no_handphone", $$v)
      },
      expression: "form.no_handphone"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                        Lama Mengajar\n                        "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan Lama Mengajar",
      "outlined": "",
      "dense": "",
      "maxlength": "3",
      "rules": [
        function (v) { return !!v || 'Lama Mengajar Wajib Diisi!'; } ],
      "required": "",
      "suffix": "Tahun"
    },
    model: {
      value: (_vm.form.teaching_duration),
      callback: function($$v) {
        _vm.$set(_vm.form, "teaching_duration", $$v)
      },
      expression: "form.teaching_duration"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(" Alumni "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "placeholder": "Masukan Alumni Konsultan",
      "outlined": "",
      "dense": "",
      "maxlength": "60",
      "rules": [
        function (v) { return !!v || 'Alumni Konsultan Wajib Diisi!'; } ],
      "required": ""
    },
    model: {
      value: (_vm.form.university),
      callback: function($$v) {
        _vm.$set(_vm.form, "university", $$v)
      },
      expression: "form.university"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                        Mata Pelajaran\n                        "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "dense": "",
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Pilih Mata Pelajaran",
      "multiple": "",
      "rules": [
        function (v) { return !!v.length || 'Mata Pelajaran Wajib Diisi!'; } ],
      "required": "",
      "chips": ""
    },
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                        Status Awal "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Status Awal Wajib Diisi!'; }],
      "required": ""
    },
    model: {
      value: (_vm.form.consultant_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "consultant_status", $$v)
      },
      expression: "form.consultant_status"
    }
  }, [_c('v-radio', {
    staticClass: "radio-custom",
    attrs: {
      "label": "Aktif",
      "value": '1'
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-custom",
    attrs: {
      "label": "Nonaktif",
      "value": '0'
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-4 px-5 border-top-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                Batal\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "depressed": "",
      "color": "blew",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitProcess()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7eb94f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/ConsultantManagementForm.vue
// module id = 1632
// module chunks = 1